import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

interface ManageSubscriptionCardProps {
  onManage?: () => void;
}

export const ManageSubscriptionCard = ({
  onManage,
}: ManageSubscriptionCardProps) => {
  const { t } = useTranslations();

  return (
    <div className="border-dark-100 flex h-[144px] w-full max-w-[1000px] items-center justify-between rounded-[18px] border border-solid bg-white px-8">
      <div className="flex flex-col gap-1">
        <span className="text-dark font-secondary text-xl font-semibold leading-[33px]">
          {t({
            id: "cx-plans-page.manage-subscription-card.title",
            defaultMessage: "Manage Subscription",
          })}
        </span>
        <span className="text-dark-700 font-secondary max-w-[520px] text-sm leading-[21px]">
          {t({
            id: "cx-plans-page.manage-subscription-card.description",
            defaultMessage:
              "Get Invoices, update your payment method, and adjust your subscription in Stripe",
          })}
        </span>
      </div>

      <Button variant="primary" iconEnd={<ArrowRightIcon />} onClick={onManage}>
        {t({
          id: "cx-plans-page.manage-subscription-card.button",
          defaultMessage: "Manage Subscription",
        })}
      </Button>
    </div>
  );
};
